import React, { useState } from 'react';
import ModalBase from './ModalBase';
import Account from '@/components/common/Account';

export default function ModalAccount({ showModal, setShowModal }) {

    let [isEdit, setIsEdit] = useState(false);
    let [isAnonymous, setIsAnonymous] = useState(false);

    const onClose = () => {
        setIsEdit(false)
        setIsAnonymous(false)
        setShowModal(false)
    }

    const onButton = (isRight) => {
        if (isRight) {
            if (isEdit) {
                setIsEdit(false)
            } else {
                setIsEdit(true)
            }
        } else {
            setIsAnonymous(!isAnonymous)
        }
    }

    return (
        <ModalBase height='h-[700px]' showModal={showModal} setShowModal={onClose} title={'sideNavigationDrawer.accountSettings'} onButton={onButton} buttonL={isEdit ? null : isAnonymous ? 'accountSettings.gotoPersonalS' : 'accountSettings.gotoPublicS'} buttonR={isEdit ? 'footer.finish' : 'footer.edit'}>
            <Account isEdit={isEdit} isAnonymous={isAnonymous} />
        </ModalBase>
    )
}